import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PartnerForm, Event } from '../../../../interfaces';
import { UserDataApi } from '../../../../../assets/js/lb-sdk/services';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-credential-form',
  templateUrl: './credential-form.component.html',
  styleUrls: ['./credential-form.component.css']
})
export class CredentialFormComponent implements OnInit {
  @Input() partner: PartnerForm;
  @Output('submit') acknowledge = new EventEmitter<Event>();
  REGEX = {
    USERNAME: /^[a-zA-Z]+[a-zA-Z0-9_]*$/,
    USERCODE: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&#;:<>,.`~_\-\+\[\]\\\\/\|\{\}\'\"\=\^\(\)])[A-Za-z\d$@$!%*?&#;:<>,.`~_\-\+\[\]\\\\/\|\{\}\'\"\=\^\(\)]{8,}$/
  };

  constructor(private userDataApi: UserDataApi) { }

  ngOnInit() { }

  submit(form) {
    if (form.valid && this.partner.retypeUsercode === this.partner.usercode) {
      this.acknowledge.emit({ event: 'started' });
      this.partner.validCredentials = false;
      this.userDataApi
        .matchUsername(this.partner.username)
        .pipe(finalize(() => {
          this.acknowledge.emit({ event: 'ended' });
        }))
        .subscribe(
          hasMatch => {
            if (hasMatch.response) {
              this.acknowledge.emit({ event: 'failed', data: 'Username already used' });
              this.partner.usernameUsed = true;
            } else {
              this.acknowledge.emit({ event: 'success' });
              this.partner.usernameUsed = false;
              this.partner.validCredentials = true;
            }
          },
          error => {
            this.acknowledge.emit({ event: 'failed', data: error.message });
          }
        );
    } else {
      this.acknowledge.emit({ event: 'failed' });
    }
  }

  onUsernameChange() {
    this.partner.validCredentials = false;
    this.partner.usernameUsed = false;
  }
}
